module.exports = __webpack_public_path__ + "static/img/9.623f369.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/zh/9.png
// module id = TFKo
// module chunks = 0